<template>
  <div>
    <div v-if="canPlay" class="bikkuraponPlayButton" @click="openPlayBikkuraponModal(true)">
      <img v-if="!isWinRateChangeEnabled" src="@/assets/images/tap.svg" alt="" />{{
        $t('bikkuraPon.pressToStartBikkuraPon')
      }}
    </div>
    <div v-else class="sideDeBikkurapon" @click="toggleBubble()">
      <div class="sideDeBikkurapon__top">
        <div v-if="!isWinRateChangeEnabled" class="sideDeBikkurapon__icon">
          <bikkurapon-icon />
        </div>
        <div class="sideDeBikkurapon__progressArea">
          <div class="sideDeBikkurapon__progressArea__price">
            <b>{{ sideMenuProgressPrice }}</b>
            /<small>{{ getPriceWithUnit(sideMenuDrawAmount) }}</small>
          </div>
          <div class="sideDeBikkurapon__progressArea__progressBar">
            <div :style="styles" class="sideDeBikkurapon__progressArea__progressBar__inner" />
          </div>
        </div>
      </div>
      <div class="sideDeBikkurapon__title">
        {{ bikkuraPonText }}
      </div>
    </div>

    <div v-if="isShopMenuPage && canPlay" class="speechBubble achieved">
      <div class="speechBubble--achieved">
        <div class="speechBubble--achieved">
          <div class="speechBubble--achieved__title">
            {{ $t('bikkuraPon.startBikkuraPon') }}
          </div>
          <div class="speechBubble--achieved__iconArea">
            <img src="@/assets/images/gacha.svg" alt="" />
          </div>
          <div class="speechBubble--achieved__textArea">
            <span>{{ $t('bikkuraPon.howToStartBikkuraPon') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="isShopMenuPage && !canPlay && showBubble"
      class="speechBubble unAchieved"
      :class="{ 'is-us': isSelectedUs }"
      @click="toggleBubble()"
    >
      <div class="speechBubble--unAchieved__closeIcon">
        <img src="@/assets/images/icn_x_mark.svg" width="8" alt="" />
      </div>
      <div class="speechBubble--unAchieved">
        <div class="speechBubble--unAchieved__title">
          <span>{{ $t('bikkuraPon.smartPhoneOrderLimited') }}</span>
        </div>
        <div class="speechBubble--unAchieved__iconArea">
          <img v-if="isTw" src="@/assets/images/bikkurapon_target_taiwan.png" width="40" alt="" />
          <img v-else-if="isCn" src="@/assets/images/bikkurapon_target_cn.png" width="40" alt="" />
          <img v-else-if="isUs" src="@/assets/images/bikkurapon_target_us.png" width="40" alt="" />
          <img v-else src="@/assets/images/bikkurapon_target.png" width="40" alt="" />
        </div>
        <div class="speechBubble--unAchieved__textArea" :class="{ 'is-us': isSelectedUs }">
          {{ $t('bikkuraPon.bikkuraPonExplanationBefore') }}
          {{ getPriceWithUnit(sideMenuDrawAmount) }}
          {{ $t('bikkuraPon.bikkuraPonExplanationAfter') }}
        </div>
      </div>
    </div>
    <div class="count">{{ totalWinningCount }}</div>
    <bikkurapon-modals :possible-count-to-play="possibleTotalCountToPlay" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import BikkuraponModals from '@/components/modal/BikkuraponModals'
import BikkuraponIcon from '@/components/images/BikkuraponIcon'

export default {
  components: {
    BikkuraponModals,
    BikkuraponIcon,
  },
  data() {
    return {
      showBubble: true,
    }
  },
  computed: {
    ...mapGetters({
      shopId: 'seat/getShopId',
      seatNo: 'seat/getSeatNo',
      token: 'auth/getToken',
      isBikkuraponEnabled: 'seat/getBikkuraponEnabled',
      bikkuraponAvailablePlayCount: 'seat/getBikkuraponAvailablePlayCount', // ビッくらポン合計抽選可能回数
      bikkuraponDrawedCount: 'seat/getBikkuraponPlayedCount', // ビッくらポン抽選実施回数
      bikkuraponWinningCount: 'seat/getBikkuraponWinningCount', // ビッくらポン当選回数
      isSideMenuEnabled: 'seat/getSideMenuBikkuraponEnabled',
      sideMenuDrawAmount: 'seat/getSideMenuBikkuraponLotteryAmount', // スマホでビッくらポン実施金額
      sideMenuAmount: 'seat/getSideMenuBikkuraponSideMenuAmount', // サイドメニュー合計金額
      sideMenuDrawedCount: 'seat/getSideMenuBikkuraponPlayedCount', // スマホでビッくらポン抽選実施回数
      sideMenuWinningCount: 'seat/getSideMenuBikkuraponWinningCount', // スマホでビッくらポン当選回数
      isShowingPlayBikkuraponModal: 'modal/isShowingPlayBikkuraponModal',
      isShowingBikkuraponBusyModal: 'modal/isShowingBikkuraponBusyModal',
      isShowingBikkuraponAnimationModal: 'modal/isShowingBikkuraponAnimationModal',
      winRateChangeEnabled: 'seat/getWinRateChangeEnabled',
      language: 'setting/getLanguage',
    }),
    styles() {
      return {
        '--progress': `${this.sideMenuProgressPercent}%`,
      }
    },
    sideMenuProgress() {
      return this.sideMenuAmount / this.sideMenuDrawAmount
    },
    sideMenuCount() {
      return this.getInteger(this.sideMenuProgress)
    },
    sideMenuProgressPercent() {
      return Number(Math.round(this.getDecimals(this.sideMenuProgress) * 100)) // スマホでビッくらポン抽選実施までの金額比率(0 ~ 100%)
    },
    sideMenuProgressPrice() {
      const price = this.isUs
        ? ((this.sideMenuAmount - this.sideMenuDrawAmount * this.sideMenuCount) / 100).toFixed(2)
        : this.sideMenuAmount - this.sideMenuDrawAmount * this.sideMenuCount
      return price // スマホでビッくらポン抽選実施までの金額
    },
    possibleSideMenuCountToPlay() {
      return this.sideMenuCount - this.sideMenuDrawedCount // スマホでビッくらポンの抽選を実施できる回数
    },
    possibleCountToPlay() {
      return this.bikkuraponAvailablePlayCount - this.bikkuraponDrawedCount // ビッくらポンの抽選を実施できる回数
    },
    possibleTotalCountToPlay() {
      return this.possibleCountToPlay + this.possibleSideMenuCountToPlay // ビッくらポンもしくはスマホでビッくらポンの抽選を実施できる回数
    },
    canPlay() {
      return 1 <= this.possibleTotalCountToPlay
    },
    totalWinningCount() {
      return this.bikkuraponWinningCount + this.sideMenuWinningCount
    },
    isShopMenuPage() {
      return this.$route.name === 'shopMenu'
    },
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isTw() {
      return this.defaultLanguage === 'zh-tw'
    },
    isCn() {
      return this.defaultLanguage === 'zh-cn'
    },
    isUs() {
      return this.defaultLanguage === 'us'
    },
    isSelectedUs() {
      return this.language === 'us'
    },
    bikkuraPonText() {
      return this.defaultLanguage === 'ja'
        ? this.$t('bikkuraPon.bikkura-pon-jp')
        : this.$t('bikkuraPon.bikkura-pon')
    },
    isWinRateChangeEnabled() {
      return this.winRateChangeEnabled === 1
    },
  },
  methods: {
    ...mapActions({
      setShowingPlayBikkuraponModal: 'modal/setShowingPlayBikkuraponModal',
    }),
    toggleBubble() {
      this.showBubble = !this.showBubble
    },
    getInteger(number) {
      // 数値の整数を取得
      return Math.floor(number)
    },
    getDecimals(number) {
      // 数値の小数を取得
      return parseFloat('0.' + String(number).split('.')[1])
    },
    openPlayBikkuraponModal() {
      this.setShowingPlayBikkuraponModal(true)
    },
    getPriceWithUnit(price) {
      switch (this.defaultLanguage) {
        case 'ja':
          return `${price}${this.$t('common.yen')}`
        case 'zh-tw':
          return `${price}${this.$t('common.twGen')}`
        case 'zh-cn':
          return `${price}${this.$t('common.cnGen')}`
        case 'us':
          return `${this.$t('common.dollar', { price: (price / 100).toFixed(2) })}`
        default:
          return this.$t('common.yen')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.sideDeBikkurapon {
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 359px) {
    max-width: 100px;
  }

  &__top {
    display: flex;
    flex-direction: row;
    width: 100%;
  }
  &__icon {
    width: 20%;
  }
  &__progressArea {
    flex-grow: 1;

    &__price {
      font-size: 0.85rem;
      line-height: 1;
    }
    &__progressBar {
      margin: 0;
      padding: 0;
      margin-top: 3px;
      margin-bottom: 3px;
      border-radius: 10px;
      height: 6px;
      width: 100%;
      border: solid 1px #242424;
      .is-app & {
        border: solid 1px #fff;
      }
      &__inner {
        margin-top: -1px;
        margin-left: -1px;
        width: var(--progress);
        height: 6px;
        background-color: red;
        border: solid 1px #242424;
        border-radius: 10px;
        .is-app & {
          border: solid 1px #fff;
        }
      }
    }
  }
  &__title {
    white-space: nowrap;
    font-size: 0.6rem;
    line-height: 1;
    min-width: 110px;
    @media (max-width: 359px) {
      font-size: 10px;
      transform: scale(0.9);
      transform-origin: 0, 0;
    }
  }
}

@keyframes yurasu {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(10deg);
  }
  50% {
    transform: rotate(0deg);
  }
  75% {
    transform: rotate(-11deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

.speechBubble {
  position: absolute;
  bottom: 60px;
  right: 10px;
  color: #212529;
  padding: 8px;
  border: solid 1px #ccc;
  border-radius: 15px;
  background-color: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);

  &.is-us {
    padding: 12px;
  }
  &unAchieved {
    width: 100%;
  }
  &::before {
    content: '';
    position: absolute;
    right: 0;
    bottom: -11px;
    left: 0;
    width: 0px;
    height: 0px;
    margin: auto;
    border-style: solid;
    border-color: #ccc transparent transparent transparent;
    border-width: 11px 11px 0 11px;
  }
  &::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: -10px;
    left: 0;
    width: 0px;
    height: 0px;
    margin: auto;
    border-style: solid;
    border-color: #fff transparent transparent transparent;
    border-width: 10px 10px 0 10px;
  }
  &--unAchieved {
    &__closeIcon {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: -8px;
      top: -8px;
      width: 24px;
      height: 24px;
      border: 2px solid #fff;
      border-radius: 50%;
      background: #242424;
    }
    &__title {
      margin: 0 auto 8px;
      font-size: 13px;
      font-weight: bold;
    }
    &__iconArea {
      margin-bottom: 8px;
    }
    &__textArea {
      font-size: 0.75rem;
      line-height: 1.5;
      &.is-us {
        text-align: left;
        white-space: pre-line;
      }
    }
  }
  &--achieved {
    &__title {
      margin: 0 auto 8px;
      font-size: 13px;
      font-weight: bold;
    }
    &__iconArea {
      margin-bottom: 8px;
      transform: translate3d(0, 0, 0);
      img {
        height: 1.5rem;
        animation: yurasu infinite 1s linear;
      }
    }
    &__textArea {
      font-size: 0.75rem;
      line-height: 1.5;
      font-weight: bold;

      @media (max-width: 359px) {
        font-size: 0.6875rem;
      }
    }
  }
}

.bikkuraponPlayButton {
  background-color: #d21b24;
  border-bottom: 2px solid #ad1219;
  border-radius: 5px;
  line-height: 1rem;
  font-size: 0.7rem;
  font-weight: bold;
  height: 40px;
  min-width: 108px;
  padding: 3px 4px 0;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: pre-wrap;
  @media (max-width: 360px) {
    font-size: 0.6rem;
  }
  img {
    transform: translate3d(0, 0, 0);
    animation: yurasu infinite 1s linear;
    margin-top: -6px;
    margin-right: 3px;
    height: 1.3rem;
  }
  &:active {
    border-bottom: none;
    margin-top: 2px;
    margin-bottom: -2px;
    height: 38px;
  }
}
.count {
  position: absolute;
  right: 2px;
  bottom: 5px;
  color: #999;
  font-size: 0.8rem;
}
::v-deep {
  .sideDeBikkurapon__icon svg path,
  .sideDeBikkurapon__icon svg polygon,
  .sideDeBikkurapon__icon svg rect {
    fill: #444;
  }
}
.is-app .sideDeBikkurapon::v-deep .sideDeBikkurapon__icon svg path,
.is-app .sideDeBikkurapon::v-deep .sideDeBikkurapon__icon svg polygon,
.is-app .sideDeBikkurapon::v-deep .sideDeBikkurapon__icon svg rect {
  fill: #c9caca;
}
.speechBubble--achieved__textArea {
  white-space: pre-wrap;
}
</style>
